import {Box} from 'platform/foundation';

import {isString} from 'ramda-adjunct';

import {vehiclesRoutes} from '@dms/routes';
import {DmsDataGrid, DmsDataGridProps} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export const SelectVehicleDialogDataGrid = (props: Partial<DmsDataGridProps>) => {
  const navigateTo = useNavigate();

  const actionCallback: ActionCallback = ({actionKey, rowId}) => {
    if (!isString(rowId)) {
      return;
    }

    switch (actionKey) {
      case 'detail':
        navigateTo(composePath(vehiclesRoutes.detail, {params: {id: rowId}}));
        break;
      default:
        // TODO: Create warn utils T20-17310
        console.warn(`Action callback was not specified for action ${actionKey}`);
        break;
    }
  };

  return (
    <Box height="60vh">
      <DmsDataGrid
        gridCode="business-case-add-vehicle"
        actionCallback={actionCallback}
        onRowSelectionChange={props.onRowSelectionChange}
      />
    </Box>
  );
};
